import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  icon: '📚',
  text: '4.000+ patrones'
}, {
  icon: '🧶',
  text: '50+ categorías'
}, {
  icon: '📁',
  text: 'Archivos organizados'
}, {
  icon: '⭐',
  text: 'Actualizaciones constantes'
}];
export function Abundance() {
  return <section className="py-12 px-6 bg-rose-deep text-white text-center" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-19">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 font-serif" data-id="element-20">
            NO ES UN CURSO. ES UNA BIBLIOTECA COMPLETA.
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto" data-id="element-21">
            Miles de patrones organizados para que siempre tengas nuevas ideas y
            nunca vuelvas a quedarte sin inspiración.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-22">
            {stats.map((stat, i) => <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4 flex flex-col items-center justify-center gap-2" data-id="element-23">
                <span className="text-3xl" data-id="element-24">{stat.icon}</span>
                <span className="font-semibold text-sm md:text-base" data-id="element-25">
                  {stat.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}